import { forwardRef } from 'react'
import { CircularProgress } from '@mui/material'
import * as $ from './IconButton.styled'
import type { IconButtonProps } from './IconButton.types'

export type { IconButtonType, IconButtonProps } from './IconButton.types'

const spinnerSize = {
  tiny: 14,
  small: 16,
  medium: 20,
  large: 20,
} as const

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { size = 'medium', kind = 'neutral', variant = 'tertiary', sx, loading, cancellable, children, disabled, ...props },
    ref,
  ) => {
    const isCancellableLoading = Boolean(loading && cancellable)

    return (
      <$.IconButton
        sx={sx}
        ref={ref}
        kind={isCancellableLoading ? 'destructive' : kind}
        size={size}
        variant={variant}
        disabled={!isCancellableLoading && Boolean(disabled || loading)}
        {...props}
      >
        {loading && <CircularProgress size={spinnerSize[size]} color="inherit" />}
        {!loading && children}
      </$.IconButton>
    )
  },
)

IconButton.displayName = 'IconButton'
